"use strict";

exports.__esModule = true;
exports.getLocalizedStringField = getLocalizedStringField;

var _ = require("./");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getLocalizedStringField(props) {
  const schema = (0, _.getLocalizedStringSchema)(props);
  const formData = (0, _.getLocalizedStringFormData)(_extends({}, props, {
    schema: schema
  }));
  return _extends({}, props, {
    formData: formData,
    schema: schema,
    uiSchema: _extends({}, props.uiSchema, {
      "ui:field": "localizedString"
    })
  });
}